import React, { SVGProps } from 'react'
import { cn } from '../utils'

export interface IconProps extends SVGProps<SVGSVGElement> {
  size?: number
}

export function withDefaultIconProps(
  IconComponent: React.ComponentType<SVGProps<SVGSVGElement>>,
  size: number
) {
  const WrappedIcon = (props: IconProps) => {
    const { className, width, height, ...svgProps } = props

    return (
      <IconComponent
        className={cn('flex-shrink-0 inline-block fill-current', className)}
        width={width ?? size}
        height={height ?? size}
        {...svgProps}
      />
    )
  }
  WrappedIcon.displayName = `withDefaultIconProps(${(IconComponent.displayName ?? IconComponent.name) || 'Component'})`
  return WrappedIcon
}
